import React from 'react';
import PendingProductInstanceProvisionTableView from '../../views/pending-product-instance/provision-table';
import { PendingProductInstanceCollection } from '../../services/collection';
import { withRouter } from 'react-router-dom';

class PendingProductInstanceProvisionTableScreen extends React.Component {

  state = {
    disabled: false,
    selected: null,
  };

  onSelect = (unused, selected) => this.setState({
    selected
  });

  onDecline = async () => {
    const { selected } = this.state;
    const { list } = this.props;
    if (!selected) {
      return null;
    }
    const found = list.find(({ hexObjectId }) => hexObjectId === selected.hexObjectId);
    if (!found) {
      return null;
    }
    await PendingProductInstanceCollection.actions.decline(found, !found.declined)
      .catch(error => {
        console.warn(error);
        alert('Failed to decline pending product instance');
      });
  };

  onProvision = () => {
    const { selected } = this.state;
    const { history } = this.props;
    if (!selected) {
      return null;
    }
    history.push(`/pending-product-instance/provision/${selected.hexObjectId}`);
  };

  render() {
    const { onSelect, onDecline, onProvision } = this;
    const { selected, disabled } = this.state;
    const { loading, list = [] } = this.props;
    return (
      <PendingProductInstanceProvisionTableView
        disabled={disabled || loading}
        items={list}
        onSelect={onSelect}
        selected={selected ? selected.hexObjectId : null}
        onDecline={onDecline}
        onProvision={onProvision}
      />
    );
  }

}

export default PendingProductInstanceCollection.connect((state) => state)(withRouter(PendingProductInstanceProvisionTableScreen));


// WEBPACK FOOTER //
// ./src/app/pending-product-instance/index.js